import { render, staticRenderFns } from "./ManualForm.vue?vue&type=template&id=22e53763&"
import script from "./ManualForm.vue?vue&type=script&lang=js&"
export * from "./ManualForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports